export default "__VITE_ASSET__BVO3205Q__"